import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'date',
    pure: true
})
export class DatePipeMock implements PipeTransform {
    public name = 'date';

    public transform(query: string, ...args: any[]): any {
        return query;
    }
}
